export default __webpack_public_path__ + "static/media/abril.cdc46077.jpg";